module.exports = __webpack_public_path__ + "img/google-logo.ff629c02.png";